import React from 'react'

import { Dashboard, PageLayout, SideSummary } from '@components'
import { LeavingGuard } from '@components/utils/LeavingGuard'
import { BackButton, HeadContent, SaveShortcutListener } from '@fourthwall/components'
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar'
import { routing } from '@utils/routing'

import { useSingleSeriesContext } from './hooks/useSingleSeriesContext'
import { ArtworkFields } from './modules/ArtworkFields'
import { DetailsFields } from './modules/DetailsFields'
import { ThumbnailFields } from './modules/ThumbnailFields'
import { SingleSeriesProvider } from './providers/SingleSeriesProvider/SingleSeriesProvider'

export const SingleSeriesCreateComponent = () => {
  const { form, isLoading } = useSingleSeriesContext()

  return (
    <>
      <HeadContent title="Create a new video series" />

      <PageLayout
        leftContent={
          <>
            <DetailsFields />
            <ThumbnailFields />
            <ArtworkFields />
          </>
        }
        rightContent={
          <SideSummary>
            <SideSummary.Item title="Video series">
              Create a collection of selected videos, whether for a show, playlist, or series.
            </SideSummary.Item>
          </SideSummary>
        }
      >
        <Dashboard.ItemViewHeader
          name="Create a new video series"
          backButton={<BackButton label="Video series" to={routing.memberships.series.self} />}
        />
      </PageLayout>

      <SaveShortcutListener disabled={!form.dirty} onSave={form.submitForm} />
      <ConfirmBar
        isOpen={form.dirty}
        isLoading={isLoading}
        onConfirm={form.submitForm}
        onCancel={form.resetForm}
      />
      <LeavingGuard when={form.dirty} isValid={form.isValid} onSave={form.submitForm} />
    </>
  )
}

export const SingleSeriesCreate = () => (
  <SingleSeriesProvider>
    <SingleSeriesCreateComponent />
  </SingleSeriesProvider>
)
